import { render } from "./DarkSwtichBtn.vue?vue&type=template&id=151bc2c1&ts=true"
import script from "./DarkSwtichBtn.vue?vue&type=script&lang=ts"
export * from "./DarkSwtichBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__